import { GroupCandidate } from './group-candidate';

export class CandidateGroupAttempt {
  attemptsNumber: number;
  groupCandidates: GroupCandidate[];

  constructor(stats?: Partial<CandidateGroupAttempt>) {
    Object.assign(this, stats);
  }
}
